import React from 'react';
import { Image, Text, View } from 'react-native';
import { getMediumFont } from '../../utils/Utils';
import { img_success } from '../../utils/ImagesManagementUtils';
import { Android } from '../../utils/DictionaryManagementUtils';
//= ========================================================================

const SaveToContacts = ({

  txt, globJSON, simPlatform, isFilled,
}) => {
  const { colors } = globJSON.configurations.theme;
  const myStyles = {
    container: {
      marginTop: simPlatform === Android ? 17 : 12,
      marginBottom: 7,
      backgroundColor: colors.app_background_color,
      flexDirection: 'row',
    },
    circleButton: {
      width: 16,
      height: 16,
      borderColor: colors.border_color,
      borderWidth: 0.6,
      borderRadius: globJSON.configurations.theme.radius.elements_shape_square ? 3 : 9,
      backgroundColor: isFilled ? colors.primary_cta_color : colors.app_background_color,
    },
    textStyle: {
      margin: 'auto',
      marginLeft: 5,
      fontFamily: `${getMediumFont(globJSON, simPlatform)}`,
      fontSize: 9.3,
      color: colors.primary_font_color,
    },
    icon: {
      minWidth: '100%',
      minHeight: '100%',
    },
  };
  return (
    <View style={myStyles.container}>
      <View style={myStyles.circleButton}>
        {isFilled
        && (
        <Image
          fadeDuration={0}
          resizeMode="contain"
          style={myStyles.icon}
          source={img_success}
        />
        )}
      </View>
      <Text style={myStyles.textStyle}>
        {txt}
      </Text>
    </View>
  );
};
export default SaveToContacts;
